import { useSpotSwapPair } from '~/state/dex/hooks'
import TokenLogo from '~/components/TokenLogo'
import { FlexContainer } from '~/components/Layout'
import { getNetworkLogo, getChainName } from '~/utils/chain'
import { formatFormAmount } from '~/utils/numbers'
import styled from 'styled-components'
import { SwapArrowIcon } from '~/components/icons'

interface Props {
  inputTokenAmount: string
  outputTokenAmount: string
}

const Container = styled.div`
  margin: 32px 0 20px;
  width: 100%;
`

const TokenRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  margin: 0;
  width: 100%;
`

const TokenAmount = styled.div`
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 20px;
  font-weight: 500;
  line-height: 120%;
`

const StyledTokenLabel = styled(FlexContainer)`
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textStrong};
`

const StyledTokenNetworkLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16.8px;
  color: ${({ theme }) => theme.colors.textCaption};
`

const TokenItem: React.FC<{
  token: SpotSwapToken
}> = ({ token }) => {
  const { logo, symbol, chainId } = token || {}
  const networkLogo = getNetworkLogo(chainId)
  const networkName = getChainName(chainId)
  return (
    <StyledTokenLabel gap={8} align="center">
      <TokenLogo
        large
        logo={logo}
        symbol={symbol}
        space={0}
        networkLogo={networkLogo}
        showNetworkBadge={true}
      />
      <div>
        <span>{symbol}</span>

        <StyledTokenNetworkLabel>{`on ${networkName}`}</StyledTokenNetworkLabel>
      </div>
    </StyledTokenLabel>
  )
}

const TokensChangeArea: React.FC<Props> = ({
  inputTokenAmount,
  outputTokenAmount,
}) => {
  const [inputToken, outputToken] = useSpotSwapPair()

  return (
    <Container>
      <TokenRow>
        <TokenItem token={inputToken} />
        <div style={{ textAlign: 'right' }}>
          <TokenAmount>{inputTokenAmount}</TokenAmount>
        </div>
      </TokenRow>
      <SwapArrowIcon />
      <TokenRow>
        <TokenItem token={outputToken} />
        <div style={{ textAlign: 'right' }}>
          <TokenAmount>{formatFormAmount(outputTokenAmount)}</TokenAmount>
        </div>
      </TokenRow>
    </Container>
  )
}

export default TokensChangeArea
